/**
 * Returns a key that is guaranteed to be unique for a course, also changing in
 * case the content of the course has been updated.
 */
function courseToKey(course) {
  return `${course.id}-${course.__internalId}-${course.title}-${course.levels.join(".")}-${course.subjects.join(".")}`;
}

export { courseToKey };
//# sourceMappingURL=course-to-key.js.map
